module.exports = __webpack_public_path__ + "media/images/application/template/envelope-ae8782797abffb931988a00a79f8ea0e.svg";